const ACTIVE_INTERVIEW_ROUTE_KEY = "lm_active_interview_route";

const ACTIVE_ROUTE_RE = /^\/(?:prepare|interview)\/([^/?#]+)/;

function storage() {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function isActiveInterviewRoute(pathname = "") {
  return ACTIVE_ROUTE_RE.test(String(pathname || ""));
}

export function activeInterviewSessionIdFromRoute(route = "") {
  return String(route || "").match(ACTIVE_ROUTE_RE)?.[1] || null;
}

export function rememberActiveInterviewRoute(pathname = "", search = "") {
  const path = String(pathname || "");
  if (!isActiveInterviewRoute(path)) return null;
  const route = `${path}${String(search || "")}`;
  try {
    storage()?.setItem(ACTIVE_INTERVIEW_ROUTE_KEY, route);
  } catch { /* sessionStorage unavailable */ }
  return route;
}

export function getRememberedActiveInterviewRoute() {
  try {
    const route = storage()?.getItem(ACTIVE_INTERVIEW_ROUTE_KEY) || "";
    return isActiveInterviewRoute(route) ? route : null;
  } catch {
    return null;
  }
}

export function getRememberedActiveInterviewSessionId() {
  return activeInterviewSessionIdFromRoute(getRememberedActiveInterviewRoute());
}

export function clearRememberedActiveInterviewRoute() {
  try {
    storage()?.removeItem(ACTIVE_INTERVIEW_ROUTE_KEY);
  } catch { /* sessionStorage unavailable */ }
}

export function isInterviewDetourPath(pathname = "") {
  const path = String(pathname || "");
  // The answer script opened in place of the interview (inside Admin → Responsive
  // Preview's frame, 2026-11-05) keeps the interview's heartbeat going.
  return path === "/account" || path === "/downloads" || path === "/admin" || path.startsWith("/admin/")
    || path.startsWith("/answer-script/");
}

export function getInterviewReturnTarget(fallback = "/") {
  return getRememberedActiveInterviewRoute() || fallback;
}
